import ChevronDown from '@/components/Icons/ChevronDown';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@music-vine/cadence/ui';
import { cn } from '@/lib/utils';
import type { NullableOfBoardSortOrder } from '@/open-api/model';
import { ArrowDownWideNarrow } from '@music-vine/cadence/icons';
import { useState } from 'react';
import { useBoardsContext } from '../context-provider';
const OPTIONS: {
  label: string;
  value: NullableOfBoardSortOrder;
}[] = [{
  label: 'Latest',
  value: 'Latest'
}, {
  label: 'A to Z',
  value: 'Alphabetical'
}, {
  label: 'Oldest',
  value: 'Oldest'
}];
const getBoardSortOrderLabel = (order: NullableOfBoardSortOrder) => {
  const defaultLabel = 'Latest';
  if (!order) {
    return defaultLabel;
  }
  return OPTIONS.find(option => option.value === order)?.label || defaultLabel;
};
export const BoardsPageSort = ({
  disabled
}: {
  disabled?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {
    boardSortOrder,
    setBoardSortOrder
  } = useBoardsContext();
  return <Select onOpenChange={setIsOpen} onValueChange={value => {
    setBoardSortOrder(value ? value as NullableOfBoardSortOrder : 'Latest');
  }} value={boardSortOrder || 'latest'} data-sentry-element="Select" data-sentry-component="BoardsPageSort" data-sentry-source-file="BoardsPageSort.tsx">
      <SelectTrigger className={cn('h-8 w-min min-w-28 shrink-0 rounded-lg px-3 text-sm md:px-4 md:text-xs lg:min-w-32 lg:text-sm', isOpen ? 'border-pink-600 bg-pink-50 text-pink-600 dark:border-white dark:bg-gray-800 dark:text-white' : 'border-gray-100 hover:bg-gray-50 dark:border-gray-800 dark:hover:border-gray-700 dark:hover:bg-gray-800')} disabled={disabled} icon={<ChevronDown className={cn('size-2.5 duration-200 ease-out lg:size-3', isOpen ? 'rotate-180 text-pink-600 dark:text-white' : 'rotate-0 text-current')} />} data-sentry-element="SelectTrigger" data-sentry-source-file="BoardsPageSort.tsx">
        <div className="flex items-center gap-2 whitespace-nowrap">
          <ArrowDownWideNarrow className="size-3 stroke-[1.75] lg:size-4" data-sentry-element="ArrowDownWideNarrow" data-sentry-source-file="BoardsPageSort.tsx" />
          <SelectValue className="whitespace-nowrap" placeholder="Sort by" data-sentry-element="SelectValue" data-sentry-source-file="BoardsPageSort.tsx">
            {getBoardSortOrderLabel(boardSortOrder)}
          </SelectValue>
        </div>
      </SelectTrigger>
      <SelectContent position="popper" data-sentry-element="SelectContent" data-sentry-source-file="BoardsPageSort.tsx">
        {OPTIONS.map(({
        value,
        label
      }, index) => <SelectItem className="cursor-pointer [&>span]:text-base" key={value} value={value?.toString() || (index + 1).toString()}>
            {label}
          </SelectItem>)}
      </SelectContent>
    </Select>;
};